const AppConfig = {
  // মূল Flask API সার্ভার
  API_BASE_URL: 'https://taiyeba-fresh-food-main-server.sparkx-ai.shop/',
  CompanyName: 'Taiyeba Fresh Food',
  phoneNumber: '01308033644',
  contactEmail: 'contact@taiyebafreshfood.com',
  // WhatsApp লিঙ্ক
  WhatsAppLink: 'https://wa.me/01308033644',
  WhatsAppNumber: '+8801308033644',
  // Facebook Messenger লিঙ্ক
  MessengerLink: 'https://m.me/taiyebafreshfood',
  // WhatsApp ডিফল্ট মেসেজ
  WhatsAppDefaultMessage: 'Hello! I visited your website and would like some information.',
  DeliveryManURL: 'https://taiyeba-fresh-food-main-server.sparkx-ai.shop/delivery-man',
  WELCOME_COUPON_CODE: 'WELCOME10', // নতুন ব্যবহারকারীদের জন্য
};

export default AppConfig;